import { render } from "./Places.vue?vue&type=template&id=66a74b90&scoped=true"
import script from "./Places.vue?vue&type=script&lang=js"
export * from "./Places.vue?vue&type=script&lang=js"

import "./Places.vue?vue&type=style&index=0&id=66a74b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a74b90"]])

export default __exports__